<template>
  <path
    d="M10 3.00018H5C3.9 3.00018 3 3.90018 3 5.00018V19.0002C3 20.1002 3.9 21.0002 5 21.0002H10V22.0002C10 22.5502 10.45 23.0002 11 23.0002C11.55 23.0002 12 22.5502 12 22.0002V2.00018C12 1.45018 11.55 1.00018 11 1.00018C10.45 1.00018 10 1.45018 10 2.00018V3.00018ZM10 18.0002H5L10 12.0002V18.0002ZM19 3.00018H14V5.00018H18C18.55 5.00018 19 5.45018 19 6.00018V18.0002L14 12.0002V21.0002H19C20.1 21.0002 21 20.1002 21 19.0002V5.00018C21 3.90018 20.1 3.00018 19 3.00018Z"
  />
</template>
